import { Empresa } from "./Empresa.ts";

export class Convenio {
  id: number;
  nome: string;
  cnpj: string;
  empresa?: Empresa;

  constructor(id, nome, cnpj, empresa = 0) {
    this.id = id;
    this.nome = nome;
    this.cnpj = cnpj;
    this.empresa = new Empresa(empresa);
  }
}
